import React, {useEffect, useState} from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import {useTranslation} from "react-i18next";
import Button from "../inputs/Button";

const RequestPasswordDialog = ({open, setOpen, closeCallback}) => {
    const {t} = useTranslation();

    const [pwd, setPwd] = useState('');

    useEffect(() => {
        setPwd('');
    }, [open]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleUnlock = () => {
        setOpen(false);
        closeCallback(pwd);
    };

    return (
        <Dialog
            open={open}
            aria-labelledby="Security password"
            aria-describedby="Security password"
        >
            <DialogTitle id="security-password-title">{t('security_password_required_title')}</DialogTitle>
            <DialogContent>
                <DialogContentText id="security-password-description">
                    {t('security_password_required_description')}
                </DialogContentText>

                <TextField
                    label={t('label_current_password')}
                    fullWidth
                    value={pwd}
                    onChange={(e) => setPwd(e.target.value)}
                    variant="outlined"
                    type='password'
                />
            </DialogContent>
            <DialogActions>
                <Button color="primary" autoFocus onClick={handleClose}>
                    {t('back_btn')}
                </Button>
                <Button variant='contained' type='submit' color="primary" onClick={handleUnlock}>
                    {t('unlock_btn')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RequestPasswordDialog;